module.exports = __webpack_public_path__ + "img/img_banner_heike.316ed97f.png";